module.exports = __webpack_public_path__ + "static/media/Corner_After.ce67ee1d.jpg";